import { createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'owners',
  initialState, reducers
})

export function useOwners(ownerIds) {
  return useMonitoredState('owners', slice.actions, ownerIds)
}

export function useOwner(id) {
  const { owners, allLoaded: loaded } = useOwners([id])
  return { owner: owners[0], loaded }
}

export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer